<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 09:27:24
 * @fileName     : 
 * @Description  : 付款申请审核
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="付款申请名称" porp="makePaymentName">
            <el-input v-model="formInline.makePaymentName" placeholder="项目编号"></el-input>
          </el-form-item>
          <el-form-item label="供应商" porp="supplierId">
            <el-select clearable v-model="formInline.supplierId" placeholder="请选择供应商">
              <el-option v-for="item in supplierOption" :key="item.id" :label="item.supplierName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款单位" porp="ownerId">
            <el-select clearable v-model="formInline.ownerId" placeholder="请选择付款单位">
              <el-option v-for="item in ownerOption" :key="item.id" :label="item.unitName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="operate py-20 border-box">
      <!-- <el-button type="success" @click="addItem()">新增</el-button> -->
      <!-- <el-button type="primary">导出</el-button>
      <el-button type="primary">导入</el-button> -->
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
        <template #ifUploadInvoiceSlot="{ row }">
          <el-tag :type="row.ifUploadInvoice == 0 ? 'danger' : 'success'" effect="dark">
            {{ row.ifUploadInvoice == 1 ? '是' : '否' }}
          </el-tag>
        </template>
        <template #makePaymentStatusSlot="{ row }">
          <div>
            <el-tag :type="formatterState(row.makePaymentStatus, 'contract').type" effect="dark">{{
              formatterState(row.makePaymentStatus, 'contract').text }}</el-tag>
          </div>
        </template>

        <template #recordAuditStatusSlot="{ row }">
          <div>
            <el-tag :type="auditProcessStatus(row.recordAuditStatus).type" effect="dark">{{
              auditProcessStatus(row.recordAuditStatus).text }}</el-tag>
          </div>
        </template>
        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="details(row)">详情</el-button>
            <el-button type="text" @click="openReviewer(row)" v-if="row.recordAuditStatus == 0">审核</el-button>
          </div>
        </template>
      </tableComponent>

    </div>
    <my-contract-details ref="myComtractRefs" @initQueryData="queryData" :title="detailsT" :status="preStatus"
      :toExamine="toExamine" @parReviewer="reviewer"></my-contract-details>
  </div>
</template>

<script>
import myContractDetails from './components/myContractDetails.vue'
import tableComponent from '@/components/tableComponent/index.vue'
import { formatterState, auditProcessStatus } from '@/utils/index'
import { queryPageForAuditApi } from '@/api/paymentApplication/index'
import { queryBasicSuppliersListApi, queryBasicOwnersListApi } from '@/api/basicInfo/index'
export default {
  components: {
    tableComponent,
    myContractDetails
  },
  data() {
    return {
      loading: false,
      toExamine: false,
      detailsT: '付款申请审核详情',
      formInline: {
        makePaymentName: "",
        ownerId: "",
        supplierId: ""
      },
      ownerOption: [],
      supplierOption: [],
      dataList: [],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "68px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "付款申请名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "makePaymentName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 9,
          title: "付款类型", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "paymentTypeName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        // {
        //   id: 10,
        //   title: "付款期数", // 标题名称
        //   isSort: false, // 是否展示排序按钮
        //   sortState: "",
        //   width: "100px",
        //   keyName: "invoiceReserveDays", // 数据的属性值
        //   align: "right",
        //   slotName: "", // 插槽名,为空字符串时不使用
        // },
        {
          id: 11,
          title: "付款金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "paymentAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        // {
        //   id: 12,
        //   title: "付款日期", // 标题名称
        //   isSort: false, // 是否展示排序按钮
        //   sortState: "",
        //   width: "100px",
        //   keyName: "invoiceDate", // 数据的属性值
        //   align: "center",
        //   slotName: "", // 插槽名,为空字符串时不使用
        // },

        {
          id: 14,
          title: "提交人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "createByName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 15,
          title: "创建日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "145px",
          keyName: "createTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 16,
          title: "付款状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "makePaymentStatus", // 数据的属性值
          align: "center",
          slotName: "makePaymentStatusSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 17,
          title: "审核状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "recordAuditStatus", // 数据的属性值
          align: "center",
          slotName: "recordAuditStatusSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 20,
          title: "是否上传发票", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "ifUploadInvoice", // 数据的属性值
          align: "center",
          slotName: "ifUploadInvoiceSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 18,
          title: "上传发票时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "142px",
          keyName: "uploadInvoiceTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 19,
          title: "操作", // 标题名称
          fixed: "right",
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "", // 数据的属性值
          align: "left",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes: [10, 20, 100]
      }
    }
  },
  mounted() {
    this.getOwnersList();
    this.getBasicSuppliersList();
    this.queryData()
  },
  methods: {
    auditProcessStatus,
    formatterState,
    //查询
    queryData() {
      this.initData()
    },
    //初始化查询
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            makePaymentName: this.formInline.makePaymentName || "",
          },
          ownerId: this.formInline.ownerId || "",
          supplierId: this.formInline.supplierId || "",
        },
        ...item
      }
      this.loading = true;
      queryPageForAuditApi(params).then(res => {
        this.loading = false;
        this.toExamine = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({ pageSize: page })
    },
    childCurrentChange(value) {
      this.initData({ pageNum: value })
    },
    //重置搜索form
    resetData(formName) {
      this.formInline.makePaymentName = "";
      this.formInline.supplierId = "";
      this.formInline.ownerId = "";
      this.$nextTick(() => {
        this.initData()
      })
    },

    details(row) {
      this.preStatus = 'view'
      this.detailsT = '付款申请审核详情'
      this.toExamine = false;
      this.$refs.myComtractRefs.openDrawer(row)
    },
    //审核
    openReviewer(row) {
      this.toExamine = true;
      this.preStatus = 'view'
      this.detailsT = '付款申请审核详情'
      this.$store.dispatch('getRecordId', row.recordId)
      this.$store.dispatch('getApiType', 'setFinMakePaymentAuditRecordApi')
      this.$refs.myComtractRefs.openDrawer(row)
    },
    //审核完刷新页面
    reviewer() {
      this.initData()
    },
    //供应商下拉
    getBasicSuppliersList() {
      let params = {
        supplierName: ''
      }
      queryBasicSuppliersListApi(params).then(res => {
        if (res.code == 200) {
          this.supplierOption = res.data;
        }
      })
    },
    //我方负责单位下拉
    getOwnersList() {
      let params = {
        unitName: ""
      }
      queryBasicOwnersListApi(params).then(res => {
        if (res.code == 200) {
          this.ownerOption = res.data;
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }

  .operate {}
}
</style>
